import { waitForElem } from '../../utils/wait_for_elem';

/* Set event listeners for each carousel */
waitForElem('.carousel').then((elems) => {
  /* Setup the active carousel item based on the checked input */
  function carouselCheck(id: string, direction = 'left') {
    /* Use unique ID to avoid clashing event listeners */
    document.querySelectorAll<HTMLElement>(`${id} .carousel-item`).forEach((carouselItem) => {
      const activeId = Number.parseInt(document.querySelector(`${id} + .carousel-indicators input:checked`)?.id.toString().split('-')[1] ?? '0') || 0;
      const dataId = Number.parseInt((carouselItem.dataset.id ?? '').split('-')[1]);

      // Display the active page for "card" style carousels
      const activePage = document.querySelector(`${id} + .carousel-indicators .activeCarouselPage`);
      if (activePage) {
        activePage.innerHTML = `${activeId + 1}`;
      }

      /* Slide animation */
      if (carouselItem.classList.contains('active')) {
        if (direction === 'left') {
          carouselItem.classList.add('slide-right');
        }
        if (direction === 'right') {
          carouselItem.classList.add('slide-left');
        }
        carouselItem.classList.remove('active');
      }

      if (activeId === dataId) {
        carouselItem.classList.add('active');
        carouselItem.classList.remove('slide-left', 'slide-right');
      } else if (dataId === activeId + 1) {
        carouselItem.classList.add('slide-right');
      } else if (dataId === activeId - 1) {
        carouselItem.classList.add('slide-left');
      } else {
        carouselItem.classList.remove('slide-left', 'slide-right');
      }

      /* Make sure only visible (active) carousel is keyboard navigable. */
      if (activeId === dataId) {
        carouselItem.querySelectorAll('a').forEach((a) => { a.setAttribute('tabindex', '0'); });
      } else {
        carouselItem.querySelectorAll('a').forEach((a) => { a.setAttribute('tabindex', '-1'); });
      }
    });
  }

  elems.forEach((elem) => {
    const thisId = `#${elem.id.toString()}`;
    const hash = thisId.split('-').slice(1).join('-')
    /* Get checked number */
    const checked = () => Number.parseInt(document.querySelector(`${thisId} + .carousel-indicators input:checked`)?.id.split('-')[1] ?? '0');
    /* Subtract 1 for 0 index */
    const numItems = document.querySelectorAll(`${thisId} .carousel-item`).length - 1;
    /* Set event listeners on radio buttons to change carousel */
    const indicators = document.querySelectorAll(`${thisId} + .carousel-indicators label`);

    const enableAutoAdvance = () => {
      /* Auto-advance the carousel if it has the class 'home-rotator' */
      if (elem.classList.contains('home-rotator')) {
        /* Automatically rotate through carousel items every 5 seconds */
        return setInterval(() => {
          next();
        }, 5000) /* Use a 5-second interval for auto-rotation */
      } else {
        return undefined;
      }
    }

    let autoAdvance = enableAutoAdvance();

    indicators.forEach((indicator) => {
      indicator.addEventListener('click', (e) => {
        /* Prevent checking, do it with this script */
        e.preventDefault();
        const id = indicator.getAttribute('for');
        (document.querySelector(`#${id}`) as HTMLInputElement).checked = true;
        /* Set the active carousel item based on checked radio */
        carouselCheck(thisId);
        if (autoAdvance) {
          // Stop auto-rotation on manual navigation
          clearInterval(autoAdvance);
          autoAdvance = enableAutoAdvance();
        }
      });
    });

    const prev = () => {
      const currChecked = checked();
      if (currChecked === 0) {
        const input = document.querySelector(`${thisId} + .carousel-indicators #carousel-${numItems}-${hash}`)
        if (input)
          (input as HTMLInputElement).checked = true;
      } else {
        const input = document.querySelector(`${thisId} + .carousel-indicators #carousel-${currChecked-1}-${hash}`)
        if (input)
          (input as HTMLInputElement).checked = true;
      }
      carouselCheck(thisId, 'left');
    }

    const prevControls = document.querySelectorAll(`${thisId} .carousel-control-prev, ${thisId} + .carousel-indicators .carousel-control-prev`);
    prevControls?.forEach(p => {
      p.addEventListener('click', e => {
        e.preventDefault();
        prev();
        if (autoAdvance) {
          // Stop auto-rotation on manual navigation
          clearInterval(autoAdvance);
          autoAdvance = enableAutoAdvance();
        }
      })
    })

    const next = () => {
      const currChecked = checked();
      if (currChecked === numItems) {
        const input = document.querySelector(`${thisId} + .carousel-indicators #carousel-0-${hash}`)
        if (input)
          (input as HTMLInputElement).checked = true;
      } else {
        const input = document.querySelector(`${thisId} + .carousel-indicators #carousel-${currChecked+1}-${hash}`)
        if (input)
          (input as HTMLInputElement).checked = true;
      }
      carouselCheck(thisId, 'right');
    }

    const nextControls = document.querySelectorAll(`${thisId} .carousel-control-next, ${thisId} + .carousel-indicators .carousel-control-next`);
    nextControls?.forEach(n => {
      n.addEventListener('click', e => {
        e.preventDefault();
        next();
        if (autoAdvance) {
          // Stop auto-rotation on manual navigation
          clearInterval(autoAdvance);
          autoAdvance = enableAutoAdvance();
        }
      })
    })
  })
});
